<template>
  <div>
    <vehicle-selection
      :moduleKey="moduleKey"
      :fieldValidationName="fieldValidationName"
      :validationScope="validationScope"
      :vehicleMakeLabel="'Make <span>*</span>'"
      :vehicleModelLabel="'Model <span>*</span>'" />

    <div class="tla-form-group">
      <label class="tla-form-group__label tla-form-group__label--required">
        Year  <span>*</span>
      </label>
      <select
        id="PlateYear"
        class="tla-form-group__input tla-form-group__input--arrow"
        v-validate.continues="'required'"
        :data-vv-name="plateYearValidationTag"
        :data-vv-scope="validationScope"
        v-model="plateYear"
        :disabled="rangeId === null"
        name="PlateYear">
        <option selected disabled value="null">
          Select your plate year
        </option>
        <option
          v-for="(year, index) in years"
          :value="year"
          :key="`${year}${index}`">
          {{year}}
        </option>
      </select>
    </div>

    <button
      :disabled="!valuationDataSet"
      class="tla-btn tla-btn--info"
      @click="closeOverlay()"
      name="manual-vehicle-confirmation-button"
      id="manual-vehicle-confirmation-button">
      This is my car
    </button>

    <button
      class="tla-btn tla-btn--link"
      @click="prevStep()"
      name="manual-vehicle-back-button"
      id="manual-vehicle-back-button">
      Go Back
    </button>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Prop, Watch, Inject
} from 'vue-property-decorator';

import { Validator } from 'vee-validate';
import SearchQuery from '@/models/SearchQuery';
import VehicleLevelFilterComponent from './VehicleLevelFilterComponent.vue';
import Valuation from '../../models/valuation/Valuation';
import IRange from '../../models/vehicle/interfaces/range.d';
import IManufacturer from '../../models/vehicle/interfaces/manufacturer.d';

@Component({
  components: {
  'vehicle-selection': VehicleLevelFilterComponent
  }
  })
export default class ManualVehicleComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'overlayValidationScope' })
  public validationScopeName!: string;

  private moduleKey!: string;

  private plateYearValidationTag: string = 'plateYearValidationTag';

  private fieldValidationName = 'manualVehicleValidation';

  private years: string[] = [];

  private lookupResponsePlateYear: string | null = '';

  public get currentStep(): number {
    return this.$store.getters['enquiryModule/currentOverlayStep'];
  }

  public get plateYear(): string | null {
    const valuation: Valuation = this.$store.getters['vehicleValuationModule/vehicleValuation'];
    return valuation.vehicle.plateYear;
  }

  public set plateYear(plateYear: string | null) {
    this.$store.dispatch('vehicleValuationModule/submitPlateYear', plateYear);
  }

  public setYears() {
    for (let index = 0; index <= 10; index += 1) {
      const year: number = new Date().getFullYear() - index;
      this.years.push(year.toString());
    }
  }

  public prevStep() {
    this.$store.dispatch('vehicleManagementModule/submitRemoveModuleInstances', this.moduleKey);
    this.$validator.errors.remove(`${this.fieldValidationName}${this.moduleKey}`, `${this.validationScope}`);
    const step: number = this.isManualVehicle ? 2 : 1;
    this.plateYear = this.lookupResponsePlateYear;
    this.$store.dispatch('vehicleValuationModule/submitIsManualVehicle', false);
    this.$store.dispatch('enquiryModule/submitOverlayStep', this.currentStep - step);
  }

  public get isManualVehicle(): boolean {
    return this.$store.getters['vehicleValuationModule/isManualVehicle'];
  }

  public get rangeId(): number | null {
    return this.searchQuery.rangeIds;
  }

  public get searchQuery(): SearchQuery {
    return this.$store.getters[`searchQueryModule${this.moduleKey}/searchQuery`];
  }

  public get currentRange(): IRange {
    return this.$store.getters[`vehicleModule${this.moduleKey}/currentRange`];
  }

  public get currentManufacturer(): IManufacturer {
    return this.$store.getters[`vehicleModule${this.moduleKey}/currentManufacturer`];
  }

  public get validationScope(): string {
    return `${this.validationScopeName}${this.moduleKey}`;
  }

  public get valuationDataSet(): boolean {
    return this.currentManufacturer !== null && this.currentRange !== null && this.plateYear !== null;
  }

  @Watch('currentManufacturer')
  public resetValuationVehicle() {
    this.$store.dispatch('vehicleValuationModule/submitResetValuationVehicle');
  }

  public closeOverlay() {
    this.$emit('closeOverlay');
  }

  public setVehicle() {
    if (this.valuationDataSet) {
      const valuation = new Valuation();
      valuation.partExchange = 0;
      valuation.privateClean = 0;
      valuation.vehicle.plateYear = this.plateYear;
      valuation.vehicle.name = `${this.currentManufacturer!.manufacturerName} ${this.currentRange!.rangeName}`;

      this.$store.dispatch('vehicleValuationModule/submitValuationExtraData', valuation);
      this.$store.dispatch('vehicleValuationModule/submitIsManualVehicle', true);
    }
  }

  public beforeCreate() {
    this.moduleKey = this.$store.getters['vehicleValuationModule/moduleKey'];
  }

  public created() {
    this.setYears();
    this.lookupResponsePlateYear = this.plateYear;
    this.plateYear = null;
    this.$validator.validateAll(this.validationScope);
  }
}
</script>
